/**
 * Map a low-cardinality route label → product usage `feature` allowlist.
 * Keep in lockstep with proxy `internal/ontology/usageanalytics` Feature*.
 */

export type UsageFeature =
  | 'graph'
  | 'plant_view'
  | 'agent_results'
  | 'configure_agents'
  | 'dashboards_view'
  | 'dashboard_builder'
  | 'chat_llm'
  | 'reports'
  | 'ingest'
  | 'tags'
  | 'notifications'
  | 'settings'
  | 'branches'
  | 'other'

const PLANT_PREFIXES = [
  '/plant',
  '/processes',
  '/areas',
  '/compute',
  '/queries',
  '/plc',
  '/robotics',
  '/schedules',
  '/alarms',
  '/entity',
  '/model'
]

function pathOnly(routeLabel: string): string {
  const q = routeLabel.indexOf('?')
  return q === -1 ? routeLabel : routeLabel.slice(0, q)
}

function startsWithPath(path: string, prefix: string): boolean {
  return path === prefix || path.startsWith(`${prefix}/`)
}

/** Resolve the product feature for a route label from `routeLabelFromPath`. */
export function featureFromRouteLabel(routeLabel: string): UsageFeature {
  const path = pathOnly(routeLabel)
  const query = routeLabel.includes('?') ? routeLabel.slice(routeLabel.indexOf('?') + 1) : ''

  if (startsWithPath(path, '/graph')) return 'graph'
  if (PLANT_PREFIXES.some((p) => startsWithPath(path, p))) return 'plant_view'
  if (startsWithPath(path, '/runs')) return 'agent_results'
  if (startsWithPath(path, '/configure') || startsWithPath(path, '/agents')) {
    return 'configure_agents'
  }
  if (startsWithPath(path, '/dashboards')) {
    // Templates explorer (and legacy ?view=templates) count as builder.
    if (
      startsWithPath(path, '/dashboards/templates') ||
      query.includes('view=templates') ||
      path.includes('/edit')
    ) {
      return 'dashboard_builder'
    }
    return 'dashboards_view'
  }
  if (startsWithPath(path, '/documents/templates')) return 'reports'
  if (startsWithPath(path, '/ingest')) return 'ingest'
  if (startsWithPath(path, '/tags')) return 'tags'
  if (startsWithPath(path, '/notifications')) return 'notifications'
  if (startsWithPath(path, '/settings')) return 'settings'
  if (startsWithPath(path, '/branches')) return 'branches'
  if (startsWithPath(path, '/chat')) return 'chat_llm'
  return 'other'
}
